<span
    class="ds-text"
    [ngClass]="['ds-text--' + size, 'ds-text--' + weight, 'ds-text--' + theme]"
    [style.color]="color"
    [style.font-size]="fontSettings?.fontSize"
    [style.line-height]="fontSettings?.lineHeight"
    [style.font-weight]="fontSettings?.fontWeight"
>
    <ng-container *ngIf="text !== null; else projectedText">{{ text }}</ng-container>

    <ng-template #projectedText>
        <ng-content />
    </ng-template>
</span>
